import LayoutPage from '@/view/layout/LayoutApp'

export default [{
    path: '/sheet-app',
    component: LayoutPage,
    children: [{
        path: 'local/edit/:procesoElectoralId/:localVotacionId/:turno?',
        name: 'sheet-local-edit-app',
        component: () => import('@/view/sheet/2026/EditFichaLocal'),
        props: (route) => {
            return {
                localVotacionId: Number.parseInt(route.params.localVotacionId, 10),
                procesoElectoralId: Number.parseInt(route.params.procesoElectoralId, 10),
                turno: route.params.turno ? Number.parseInt(route.params.turno, 10) : null,
                esVersionApp: true,
            }
        }
    },{
        path: 'mesa/edit/:procesoElectoralId/:localVotacionId/:mesaVotacionId/:turno?',
        name: 'sheet-mesa-edit-app',
        component: () => import('@/view/sheet/2026/EditFichaMesa'),
        props: (route) => {
            return {
                localVotacionId: Number.parseInt(route.params.localVotacionId, 10),
                procesoElectoralId: Number.parseInt(route.params.procesoElectoralId, 10),
                mesaVotacionId: Number.parseInt(route.params.mesaVotacionId, 10),
                turno: route.params.turno ? Number.parseInt(route.params.turno, 10) : null,
                esVersionApp: true,
            }
        }
    }]
}]
